var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemexWordmarkPrimaryBlackNoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 520 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7464 73.8815C16.8023 86.1785 22.7145 100.175 34.9516 105.143L52.8559 60.6118C40.6187 55.6435 26.6906 61.5846 21.7464 73.8815Z",
    fill: "url(#paint0_linear_4_1009)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5133 82.2669C45.8629 96.3205 52.6196 112.316 66.6049 117.994C80.5902 123.672 96.5081 116.883 102.159 102.829L51.5133 82.2669Z",
    fill: "url(#paint1_linear_4_1009)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6405 20C116.122 27.0976 124.568 47.0922 117.505 64.6593C110.442 82.2264 90.5446 90.7136 73.063 83.616L98.6405 20Z",
    fill: "url(#paint2_linear_4_1009)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4217 46.5394C40.6595 35.9992 52.5979 30.9069 63.0869 35.1654C73.5759 39.4239 78.6434 51.4207 74.4056 61.961L36.4217 46.5394Z",
    fill: "url(#paint3_linear_4_1009)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 108.577V30H180.86C191.557 30 200.467 33.8277 207.517 41.4762C214.629 49.0389 218.178 58.3307 218.178 69.2885C218.178 80.248 214.628 89.5755 207.517 97.2103C200.466 104.787 191.555 108.577 180.86 108.577H150ZM243.507 95.2197C246.887 97.7704 251.048 99.0696 256.049 99.0696C262.997 99.0696 267.904 96.5329 270.98 91.5434L271.474 90.7411L281.294 96.3146L280.733 97.184C275.207 105.738 266.853 110 255.831 110C246.926 110 239.589 107.223 233.909 101.618L233.899 101.609C228.303 95.9373 225.518 88.7873 225.518 80.2346C225.518 71.7562 228.266 64.6452 233.785 58.9743C239.317 53.2908 246.477 50.4691 255.174 50.4691C263.461 50.4691 270.263 53.4205 275.495 59.3319C280.772 65.1389 283.407 72.1617 283.407 80.344C283.407 81.782 283.293 83.2535 283.068 84.758L282.943 85.5903H237.453C238.471 89.708 240.497 92.8978 243.507 95.2197ZM243.108 65.5461C240.212 68.0016 238.31 71.2412 237.42 75.3167H271.632C270.751 70.8818 268.87 67.5486 266.046 65.2272C262.943 62.6755 259.333 61.3995 255.174 61.3995C250.264 61.3995 246.27 62.7966 243.118 65.5381L243.108 65.5461ZM375.041 108.577H363.563V73.8858C363.563 69.8196 362.514 66.8047 360.544 64.7028C358.566 62.5931 355.92 61.509 352.5 61.509C348.661 61.509 345.653 62.7986 343.377 65.3423C341.197 67.7869 340.014 71.6639 340.014 77.1697V108.577H328.536V73.8858C328.536 69.8115 327.519 66.792 325.615 64.6907L325.609 64.6844L325.603 64.678C323.775 62.5883 321.252 61.509 317.91 61.509C314.152 61.509 311.052 62.7951 308.545 65.3684C306.157 67.8922 304.877 71.7651 304.877 77.1697V108.577H293.399V51.8921H304.877V57.2211C308.675 52.7252 313.812 50.4691 320.209 50.4691C324.033 50.4691 327.392 51.2747 330.249 52.9264C332.685 54.3353 334.716 56.3363 336.347 58.9012C340.32 53.2821 346.072 50.4691 353.485 50.4691C359.849 50.4691 365.079 52.5631 369.079 56.7925C373.087 60.9562 375.041 66.5841 375.041 73.5575V108.577ZM402.215 95.2197C405.595 97.7704 409.756 99.0696 414.758 99.0696C421.705 99.0696 426.612 96.5329 429.688 91.5434L430.183 90.7411L440.003 96.3146L439.441 97.184C433.915 105.738 425.561 110 414.539 110C405.634 110 398.297 107.223 392.617 101.618L392.608 101.609C387.011 95.9372 384.226 88.7873 384.226 80.2346C384.226 71.7562 386.974 64.6452 392.494 58.9743C398.025 53.2908 405.185 50.4691 413.882 50.4691C422.169 50.4691 428.972 53.4206 434.203 59.3322C439.48 65.1392 442.115 72.1619 442.115 80.344C442.115 81.782 442.001 83.2535 441.776 84.758L441.651 85.5903H396.161C397.179 89.708 399.205 92.8978 402.215 95.2197ZM401.826 65.5381L401.817 65.5461C398.92 68.0016 397.018 71.2412 396.128 75.3167H430.34C429.459 70.8818 427.578 67.5486 424.755 65.2272C421.651 62.6755 418.041 61.3995 413.882 61.3995C408.972 61.3995 404.979 62.7966 401.826 65.5381ZM499.964 108.577H486.368L471.533 88.5498L456.592 108.577H442.986L464.734 79.4675L444.194 51.8921H457.907L471.535 70.2745L485.164 51.8921H498.766L478.335 79.3602L499.964 108.577ZM180.86 96.9898C188.41 96.9898 194.526 94.3571 199.292 89.1012C204.073 83.8276 206.482 77.2468 206.482 69.2885C206.482 61.3302 204.073 54.7495 199.292 49.4759C194.526 44.2199 188.41 41.5872 180.86 41.5872H162.134V96.9898H180.86Z",
    fill: "#1A1D1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_1009",
    x1: 120,
    y1: 70,
    x2: 20,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_1009",
    x1: 120,
    y1: 70,
    x2: 20,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_1009",
    x1: 120,
    y1: 70,
    x2: 20,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_1009",
    x1: 120,
    y1: 70,
    x2: 20,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemexWordmarkPrimaryBlackNoBg);
export default __webpack_public_path__ + "static/media/demex_wordmark_primary_black_no_bg.71be573814895b128c3b12fd42d675e4.svg";
export { ForwardRef as ReactComponent };